module.exports = __webpack_public_path__ + "media/images/flags/1x1/mnp-30c2a6c0f025fba73eac62ee757c7d64.svg";